<template>
    <div>
        <Login v-if="!$store.getters.userIsAuthenticated"></Login>
        <fundation-layout
            v-else
            :email-label="emailLabel"
            :email-suffix="emailSuffix"
            :extra-login-data="extraLoginData"
        >
            <LayoutMain></LayoutMain>
        </fundation-layout>
    </div>
</template>

<script>
import Login from '@/components/page/Login';
import LayoutMain from '@/components/partials/ui/LayoutMain';
import LoadingFullscreen from '@/components/partials/ui/LoadingFullscreen';
import {FundationLayout} from 'fundation-app-vuejs';

export default {
    name: 'App',
    components: {
        Login,
        LayoutMain,
        LoadingFullscreen,
        FundationLayout
    },
    computed: {
        emailLabel () {
            return window.config.use_apivalo_auth === true ? 'NNi' : null;
        },
        emailSuffix () {
            return window.config.use_apivalo_auth === true ? window.config.email_suffix : null;
        },
        extraLoginData () {
            return window.config.use_apivalo_auth === true ? {user_type: 'SESAME'} : null;
        },
    },
    created(){
        this.$store.dispatch('initializeApplicationMode');
    }
};
</script>

<style lang="scss">
@import "./assets/styles/app";
@import "./assets/styles/element-variables.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue